import { render, staticRenderFns } from "./AccountVersionCardContent.vue?vue&type=template&id=8ff50912&"
import script from "./AccountVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./AccountVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports